export default function Dribbble({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M12,1C5.93,1,1,5.93,1,12s4.93,11,11,11,11-4.93,11-11S18.07,1,12,1ZM19.11,6.5c1.12,1.45,1.81,3.24,1.88,5.19-2.08-.34-4.09-.31-6.01.08-.29-.71-.59-1.4-.92-2.08,1.86-.77,3.55-1.8,5.05-3.19ZM17.72,5.06c-1.36,1.24-2.89,2.16-4.59,2.86-.83-1.5-1.81-3.01-3.02-4.72.61-.13,1.24-.2,1.88-.2,2.17,0,4.17.77,5.72,2.06ZM8.14,3.88c1.23,1.71,2.23,3.22,3.07,4.7-2.33.68-4.96,1.05-7.94,1.28.65-2.65,2.46-4.83,4.87-5.98ZM3,12s0-.07,0-.11c3.39-.24,6.44-.67,9.15-1.51.31.63.6,1.26.87,1.92-2.89.99-5.54,2.85-7.86,5.55-1.35-1.57-2.17-3.61-2.17-5.85ZM6.64,19.21c2.12-2.49,4.49-4.18,7.09-5.06.62,1.77,1.17,3.75,1.76,6.14-1.07.45-2.25.7-3.49.7-2.01,0-3.86-.67-5.36-1.79ZM17.29,19.26c-.53-2.14-1.05-3.97-1.61-5.61,1.64-.29,3.36-.28,5.15.03-.44,2.28-1.74,4.25-3.54,5.57Z"
        fill="currentColor"
      />
    </svg>
  );
}
